/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import _ from 'lodash';
import config from '../../../config';

const timelineLimit = config.timeline.limit;

export default class TimelineBackForwardButton extends React.Component {
  static propTypes = {
    range: PropTypes.object,
    offset: PropTypes.object,
    forward: PropTypes.func,
    forwardEvent: PropTypes.func,
    back: PropTypes.func,
    backEvent: PropTypes.func,
  }

  render() {
    const {
      offset, range, back, forward
    } = this.props;

    return (
      <div className='timeline-buttons'>
        <button id='left-arrow-button' className='slds-button slds-button--icon-border'
          onClick={() => {
            back(offset, range);
          }}
          disabled={offset.asDays() + range.asDays() >= timelineLimit}>
          <svg className='slds-button__icon'>
            <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#chevronleft'></use>
          </svg>
        </button>
        <button id='right-arrow-button' className='slds-button slds-button--icon-border'
          onClick={() => {
            forward(offset, range);
          }}
          disabled={offset.asDays() === 0}>
          <svg className='slds-button__icon'>
            <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#chevronright'></use>
          </svg>
        </button>
      </div>
    );
  }
}
